import { SecurityStatus } from '@shared/enums/security-status';
import { TaxResultItemType } from '@shared/enums/tax-result-item-type';
import { getSecurityStatusNameById } from '@shared/helpers/functions/get-security-status-name';
import { Mapper } from '@shared/helpers/mapper';
import { TransactionType as TransactionTypeEnum } from '@shared/helpers/enums/transaction-type';
import { TransactionType } from '@shared/models/security';
import { SecurityResponseWithNestedObjectsAuditable } from 'src/app/web-api-client';
import { SecurityGridData } from '../../models/security-grid-data';

export const mapSecurityFromResponse = (
  response: SecurityResponseWithNestedObjectsAuditable
): SecurityGridData => {
  const isGeneralRate =
    response.transactionType?.transactionTypeId ===
    TransactionTypeEnum.GeneralRates;

  return {
    securityId: response.securityId,
    name: response.name,
    isinCusip: response.isinCusip,
    investingEntityName: isGeneralRate
      ? response.generalRateEntityType?.name
      : response.entity?.name,
    entityTypeName: isGeneralRate
      ? response.generalRateEntityType?.name
      : response.entity?.entityType?.name,
    residencyJurisdictionName: isGeneralRate
      ? undefined
      : response.entity?.residencyJurisdiction?.country?.name,
    residencyJurisdictionCode: isGeneralRate
      ? undefined
      : response.entity?.residencyJurisdiction?.country?.code,
    investingJurisdictionName: response.investmentJurisdiction?.country?.name,
    securityTypeName: response.securityType?.name,
    securityTypeId: response.securityType?.securityTypeId,
    acquisitionDate: response.acquisitionDate,
    dispositionDate: response.dispositionDate,
    statusName: getSecurityStatusNameById(
      response.securityStatus?.securityStatusId
    ),
    dividendsRate:
      response.securityStatus?.securityStatusId === SecurityStatus.Approved
        ? response.securityTaxResultItems
            ?.filter(({ rate }) => rate !== null)
            .sort((a, b) => (b.rate ?? 0) - (a.rate ?? 0))
            .filter(
              item =>
                item.taxResultItemType?.taxResultItemTypeId ===
                  TaxResultItemType.Dividends ||
                item.taxResultItemType?.taxResultItemTypeId ===
                  TaxResultItemType.Interest
            )
            .map(item => `${item.rate}%`)
            .join(', ')
        : '-',
    capitalGainsRate:
      response.securityStatus?.securityStatusId === SecurityStatus.Approved
        ? response.securityTaxResultItems
            ?.filter(({ rate }) => rate !== null)
            .sort((a, b) => (b.rate ?? 0) - (a.rate ?? 0))
            .filter(
              item =>
                item.taxResultItemType?.taxResultItemTypeId ===
                TaxResultItemType.CapitalGains
            )
            .map(item => `${item.rate}%`)
            .join(', ')
        : '-',
    transactionType: Mapper.map(response.transactionType, TransactionType, [
      'transactionTypeId',
      'name',
      'description',
    ]),
    isActive: response.isActive,
    securityStatusId: response.securityStatus?.securityStatusId,
    securityStatusName: response.securityStatus?.name,
    createdBy: response.createdBy ? response.createdBy.split('|').pop() : '',
    created: response.created,
    modifiedBy: response.modifiedBy ? response.modifiedBy.split('|').pop() : '',
    modified: response.modified,
    clientName: response.entity?.client?.name,
  };
};
